import React from 'react';
import './supplierOrders.scss';

import {Logout} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import supplierOrderDetail from './supplierOrderDetail.js';

//import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { createStore } from 'devextreme-aspnet-data';

import { SimpleItem, GroupItem, Item, TabbedItem, TabPanelOptions, Tab } from 'devextreme-react/form';

import { useState, useEffect, useCallback } from "react";
import {Button as ToolbarButton} from 'devextreme-react/button';
import {Popup} from 'devextreme-react/popup';

import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { CheckBox } from 'devextreme-react/check-box';
import { formatNumber } from 'devextreme/localization';

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Format,
  //Popup,
  Form,
  Button,
  Pager,
  Paging,
 // FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitore'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitoreRiepilogo'
const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_OrdiniFornitori'
const serviceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitoreSoggetto'
const serviceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'

const debug = process.env.ENTITY_DEBUG;

const editorOptions = { readonly: true, format: '###,##0.00'};
const editorOptionsPerc = { readonly: true, format: "#0.00 '%'"};

export default function SupplierOrders(props) {

  const projectId = props.projectId;
  var isInProject = false;
  if (props.isInProject)
    isInProject = props.isInProject;

  const initYear = isInProject? 0:new Date().getFullYear();
  const initIntermediario = isInProject? 0:210;
  
  var supOrdDataGridRef = React.createRef();

  const [stati, setStati] = useState({});
  const [fornitori, setFornitori] = useState({});
  const [clienti, setClienti] = useState({});
  const [collaboratori, setCollaboratori] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [tipiSoggetto, setTipiSoggetto] = useState({});
  const [valute, setValute] = useState({});
  const [modalitaPagam, setModalitaPagam] = useState({});
  const [condizioniPagam, setCondizioniPagam] = useState({});
  const [currentId, setCurrentId] = useState(0);
  const [currentDocNo, setCurrentDocNo] = useState();
  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [isGoToProject, setIsGoToProject] = useState(false);
  const [isClosed, setIsClosed] = useState(true);

  const [currentPrj, setCurrentPrj] = useState(0);
  const [currentPrjNo, setCurrentPrjNo] = useState();
  const [isPrjSelected, setIsPrjSelected] = useState(false);

  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(initYear);
  const [fornitoreFilter, setFornitoreFilter] = useState();
  const [statoFilter, setStatoFilter] = useState();
  const [isStorico, setIsStorico] = useState(false);
  const [internoFilter, setInternoFilter] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [intermediarioFilter, setIntermediarioFilter] = useState(initIntermediario);
  const [isPopupVisible2, setPopupVisibility2] = useState(false);
  const togglePopup2 = () => {
    setPopupVisibility2(!isPopupVisible2);
  };

  const { user } = useAuth(); 

  if (!user) 
    Logout();

  const filterPayload = { 
    storico: isStorico,
    anno: annoFilter,
    fornitore: fornitoreFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    commessa: projectId,
    interno: internoFilter,
  };

  //const notesEditorOptions = { height: 38 };

  const allowedPageSizes = [5, 10, 20];

  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl3 + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  const remoteDataSource2 = createStore({

    key: 'id',
    loadUrl: serviceUrl2 + '/FindByOrdineFornitore/' + currentId,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    }    
  });

  const remoteDataSource4 = createStore({

    key: 'id',
    loadUrl: serviceUrl4 + '/FindByOrdineFornitore/' + currentId,
    updateUrl:serviceUrl4 + '/UpdateAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    }   
    
  });

  const remoteDataSource6 = createStore({

    key: 'id',
    loadUrl: serviceUrl6 + '/GetAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
  });

  function onEditingStart(e) {
    //console.log("EDITING: " + e.key);
    //QUESTO PROVOCA IL DOPPIO REFRESH DEL POPUP DELLA TESTATA
    setCurrentId(e.key);
  }

  const onEditorPreparing = (e) => {
    if(e.dataField === "fornitoreId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    if(e.dataField === "destinazioneId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    if(e.dataField === "intermediarioId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    //può approvare solo admin
    // if(e.dataField === "statoId" && e.parentType ==="dataRow"){
    //   if (!isAdmin && e.row.data.statoId === 7) 
    //     e.editorOptions.disabled = true;
    // }
    if(e.dataField === "fornitoreId" && e.parentType ==="dataRow"){
      if (!(e.row.data.statoId === 1) || e.row.data.statoId === null)
        setIsEditable(false)
      else
        setIsEditable(true)
    }

     if(e.dataField === "numeroDoc" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 6) && e.row.data.statoId != null;
    }

  }  


  useEffect(() => {

    const fetchData = async () => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineStato';
      var newUrl =  newServiceUrl + "/GetAction";

      const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl2 =  newServiceUrl2 + "/GetFornitori";

      const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
      var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

      const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
      var newUrl4 =  newServiceUrl4 + "/GetAction";

      const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
      var newUrl5 =  newServiceUrl5 + "/GetAction";

      const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
      var newUrl6 =  newServiceUrl6 + "/GetAction";

      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

      const newServiceUrl8 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoSoggetto';
      var newUrl8 =  newServiceUrl8 + "/GetAction";

      const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniOrdiniFornitori';
      var newUrl9 =  newServiceUrl9 + "/GetAction";

      const newServiceUrl10 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl10 =  newServiceUrl10 + "/GetClienti";

  

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        const response2 = await fetch(newUrl2,requestOptions);
        const json2 = await response2.json();
        if (debug === 1)
          console.log(json2);
        setFornitori(json2);

        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        if (debug === 1)
          console.log(json3);
        setCollaboratori(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        if (debug === 1)
          console.log(json4);
        setValute(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        if (debug === 1)
          console.log(json5);
        setModalitaPagam(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        if (debug === 1)
          console.log(json6);
        setCondizioniPagam(json6);

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        if (debug === 1)
          console.log(json7);
        setIntermediari(json7);

        const response8 = await fetch(newUrl8);
        const json8 = await response8.json();
        if (debug === 1)
          console.log(json8);
        setTipiSoggetto(json8);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

        const response10 = await fetch(newUrl10,requestOptions);
        const json10 = await response10.json();
        if (debug === 1)
          console.log(json10);
        setClienti(json10);

      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  function refreshDataGrid() {
    supOrdDataGridRef.instance().refresh();
  }

  const copia= (idOrdine) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitore/NewVersion/' + idOrdine;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
    }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        supOrdDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const duplica= (idOrdine) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitore/Duplicate/' + idOrdine;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        supOrdDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  function newVersion(e) {
    let result = confirm("<i>Procedere con la creazione di una nuova revisione?</i>", "Nuova revisione");
        result.then((dialogResult) => {
          if  (dialogResult) {
            copia(currentRow);
          }  
        });
  }

  function duplicate(e) {
    let result = confirm("<i>Procedere con la duplicazione dell'ordine?</i>", "Duplicazione Ordine");
        result.then((dialogResult) => {
          if  (dialogResult) {
            duplica(currentRow);
          }  
        });
  }

  function printOrder(id) {

    const url =  serviceUrl3 + "/CreateOrdineFornitorePDF/" + id;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.blob();        
        //Global.CheckResponseAuth(response);
      })
      .then(blob => {

        setTimeout(() => {          
        }, 1500);

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var slug = "Ordine";

        a.download = slug + ".pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  //afterwards we remove the element again 
        
      })

      .catch(error => { notify(error, 'error', 5000); });

  };  


  function print(e) {
    printOrder(currentRow);
    notify("Stampa ordine: " + currentDocNo);
  }


  const aggiungiACommessa= () => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/AddSupplierOrderToProject/' + currentPrj + '/' +currentRow;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function addToProject(e) {
    let result = confirm("<i>Aggiungere il documento selezionato alla Commessa " + currentPrjNo + "?</i>", "Aggiungi a Commessa");
        result.then((dialogResult) => {
          if  (dialogResult) {
            aggiungiACommessa();
            setPopupVisibility2(false);
          }  
        });
  }


  function updateMovs() {    
    let result = confirm("<i>Aggiornare i Pagamenti dell'ordine selezionato'?</i>", "Aggiorna Pagamenti");
      result.then((dialogResult) => {
      if  (dialogResult) {
        aggiornaMovimenti(currentRow);
      }  
    });
  };

  const aggiornaMovimenti= (idOrdine) => {
      
    var path = "";
    path = '/api/OrdineFornitore/UpdatePaymentMovements/';
    
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idOrdine;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }



  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentRow(data.id);
      setCurrentDocNo(data.numero);
      setIsRowSelected(true);
      if(data.statoId === 3)
        setIsClosed(true);
      else
        setIsClosed(false);
      console.log("SELECTED: " + data.id);
      //setCurrentId(e.currentSelectedRowKeys);

    } else{
      setIsRowSelected(false);
      setIsClosed(true);
    }

    if (data != null && data.statoId > 0)
      setIsGoToProject(true);
    else
      setIsGoToProject(false);
  }

  function customizeText(data) {
    return `Ordini: ${data.value}`;
  }

  function customizeData(data) {
    return `${formatNumber(data.value, '###,##0.00')}`;
  }

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuovo Ordine'
  };

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
  };

  const selectBoxOptions2 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };

  const selectBoxOptions3 = {
    width: 210,
    items: fornitori,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Fornitori>",
    showClearButton:true,
    searchEnabled:true,
    onValueChanged: (args) => {
      setFornitoreFilter(args.value);
    },
    value: fornitoreFilter,
  };

  const selectBoxOptions4 = {
    width: 180,
    items: stati,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Stato>",
    showClearButton:true,
    onValueChanged: (args) => {
      setStatoFilter(args.value);
    },
    value: statoFilter
  };

  const hideEditButton = useCallback((e) => {
    return e.row.data.statoId !== 3 && e.row.data.statoId !== 2;
  }, []);

  function onCheckValueChanged(e)  {
    setIsStorico(e.value);
  };

  function onCheckValueChanged2(e)  {
    setInternoFilter(e.value);
  };

  const onCellPrepared = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
        { if (e.data.statoId === 1)
            e.cellElement.style.cssText = "color: white; background-color: #30B7E0";
          else if (e.data.statoId === 2)
            e.cellElement.style.cssText = "color: white; background-color: orange";
          else if (e.data.statoId === 3)
            e.cellElement.style.cssText = "color: white; background-color: green";
          else if (e.data.statoId === 4)
            e.cellElement.style.cssText = "color: white; background-color: red";
          else if (e.data.statoId === 5)
            e.cellElement.style.cssText = "color: white; background-color: #DDBBFF";
          else if (e.data.statoId === 6)
          e.cellElement.style.cssText = "color: white; background-color: #558ea7";
        }
    }
  }

  function cancelAddToProject()  {
    setPopupVisibility2(false);
    setCurrentPrj(0);
    setCurrentPrjNo(0);
    setIsPrjSelected(false);
  };

  function onRowSelectionChangedPrj({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentPrj(data.id);
      setCurrentPrjNo(data.codice);
      setIsPrjSelected(true);
    } else{
      setCurrentPrj(0);
      setIsPrjSelected(false);
    }
  }

  const renderContent2 = () =>  {
    return (
      <div>

  { isPrjSelected &&
    <p>Aggiungi il documento selezionato alla Commessa <b>{currentPrjNo}</b></p>
  }
     
      <DataGrid id="grid-popup2"
        className={'dx-card wide-card'}
        dataSource={remoteDataSource6}
        showBorders={true}

        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        onSelectionChanged={onRowSelectionChangedPrj}
      >
        <Pager
            showPageSizeSelector={false}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
        />
        <Selection mode="single" />
        <Paging defaultPageSize={10} />
       
        <Toolbar>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='todo'
              hint='Conferma'
              disabled={!isPrjSelected}
              onClick={addToProject} 
            />
          </Item>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='revert'
              hint='Annulla'
              onClick={cancelAddToProject} 
            />
          </Item>    
      
        </Toolbar>
        <Column dataField="id" visible={false}/>
        <Column dataField="codice" caption="Codice" width={110}/>
        <Column dataField="nome" dataType="date" caption="Nome" />
        <Column dataField="clienteId" caption="Cliente" >
          <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
      </DataGrid>
      </div>            
    )
  }

  function onRowInserting(e) {
    e.data.createBy = user.name;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  return (
  <React.Fragment>
  { !isInProject &&  <h2 className={'content-block'}>Ordini Fornitori</h2> }
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <DataGrid id="grid-container"
          ref={ref => supOrdDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource}
          showBorders={true}

          onSelectionChanged={onRowSelectionChanged}
          //onRowExpanded={onRowExpanded}
          onEditingStart={onEditingStart}
          //onRowRemoving={onRowRemoving}
          onEditorPreparing={onEditorPreparing}
          //onExporting={onExporting}
          onCellPrepared={onCellPrepared}
          onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          dateSerializationFormat= {'yyyy-MM-dd'}
        >
         
         { !isInProject
            &&   
          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='refresh'
                hint='Aggiorna'
                onClick={refreshDataGrid} 
                />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='copy'
                hint='Duplica'
                onClick={duplicate}
                disabled={!isRowSelected} />
            </Item>       
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='inserttable'
                hint='Nuova Revisione'
                onClick={newVersion}
                disabled={isClosed} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='showpanel'
                hint='Aggiorna Pagamenti'
                onClick={updateMovs} 
                disabled={!isRowSelected}
                />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='print'
                hint='Stampa'
                onClick={print}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='columnchooser'
                hint='Aggiungi a Commessa'
                onClick={togglePopup2}
                disabled={!isGoToProject} />
            </Item>
            <Item location="after">
              <CheckBox  
                value={internoFilter} onValueChanged={onCheckValueChanged2}
                defaultValue={internoFilter}
                text="  Escludi Interni   "
              >
              </CheckBox>
            </Item> 
            <Item location="after">
              <CheckBox  
                value={isStorico} onValueChanged={onCheckValueChanged}
                defaultValue={isStorico}
                text="  Storico   "
              >
              </CheckBox>
            </Item> 
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions3} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions4} >
            </Item>

            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>
          }

      
          <Summary>
            <TotalItem
                column="numero"
                summaryType="count"
                customizeText={customizeText}
            />
            <TotalItem
              column="imponibile"
              summaryType="sum" 
              customizeText={customizeData}
              />
          </Summary>
          <Selection mode="single" />
          <HeaderFilter visible={true} />
          <Editing
            mode="popup"
            allowUpdating={true}
            allowAdding={!isInProject}
            allowDeleting={true}
            useIcons={true}
          >
          
          <Popup title="Ordine" showTitle={true} width={1200} height={780} />
            <Form>
           
              <Item itemType="group" caption="Dati Identificativi" colCount={4} colSpan={2}>
               
                <Item dataField="numeroDoc" colSpan={2} />
                <Item dataField="statoId"colSpan={2} isRequired= "true"/>
                <Item dataField="dataDoc"colSpan={2} isRequired= "true"/>
                <Item dataField="dataConsegna"colSpan={2}/>
                <Item dataField="oggetto"colSpan={4}/>
                
     
                <Item dataField="fornitoreId" colSpan={2} isRequired= "true"/>
                <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
                <Item dataField="riferimentoInternoId" colSpan={2} isRequired= "true"/>
                
                <Item dataField="master" colSpan={2}/>

                <Item dataField="riferimentoFornitore"colSpan={2} />
                <Item dataField="commessaFornitore"colSpan={2} />
                <Item dataField="numeroContratto"colSpan={2} />
                
              </Item> 

                <GroupItem caption="Riepilogo" colCount={4} colSpan={2} >
                  <TabbedItem colSpan={4}>
                    <TabPanelOptions deferRendering={false} />
                  
                    <Tab title="Acquisto" colCount={3}>
                      <SimpleItem dataField="importoLordo" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="percSconto" />
                      <SimpleItem dataField="importoSconto" editorOptions={editorOptions}/>
                  
                      <SimpleItem dataField="imponibile" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="imposte" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="importoTotale" editorOptions={editorOptions} disabled={true}/>
                    </Tab>
                    <Tab title="Imposte" colCount={3}>
                      <DataGrid id="grid-subcontainer" dataSource={remoteDataSource2}>
                        <Column dataField="id" visible={false}/>
                        <Column dataField="codiceIva"width={80}/>
                        <Column dataField="aliquotaIva"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="imponibile"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="imposta"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                      </DataGrid>
                    </Tab> 
                    <Tab title="Soggetti" colCount={3}>
                    <DataGrid id="grid-subcontainer2"
                    dataSource={remoteDataSource4}
                    >
                      <Editing
                        mode="form"
                        allowUpdating={isEditable}
                        useIcons={true}
                      >
                        <Form>
                          <Item dataField="nome"/>
                          <Item dataField="indirizzo"/>
                          <Item dataField="città"/>
                          <Item dataField="provincia"/>
                          <Item dataField="cap"/>
                          <Item dataField="nazione"/>
                          <Item dataField="piva"/>
                          <Item dataField="cf"/>
                          <Item dataField="codiceDestinatario"/>
                          <Item dataField="pec"/>
                        </Form>
                       </Editing>
                      <Column dataField="id" visible={false}/>
                      <Column dataField="tipoSoggettoId" caption="Tipo" width={120} >
                        <Lookup dataSource={tipiSoggetto} valueExpr="id" displayExpr="nome" />
                      </Column>
                      
                      <Column dataField="nome" width={200}/>
                      <Column dataField="indirizzo" width={200}/>
                      <Column dataField="città"/>
                      <Column dataField="provincia" width={80} visible={false}/>
                      <Column dataField="cap" width={80} visible={false} />
                      <Column dataField="nazione" visible={false}/>
                      <Column dataField="piva" width={120}/>
                      <Column dataField="cf" width={150}/>
                      <Column dataField="codiceDestinatario" width={120} caption="Cod. Dest." visible={false} />
                      <Column dataField="pec" width={120} visible={false}/>
                     
                    </DataGrid>
                  </Tab> 


                  </TabbedItem>
                </GroupItem>

                <Item itemType="group" caption="Dati Pagamento" colCount={4} colSpan={2}>
                  <Item dataField="valutaId" colSpan={2}/>
                  <Item dataField="modalitaPagamentoId" colSpan={2}/>
                  <Item dataField="condizioniPagamentoId" colSpan={2}/>
                  <Item dataField="condizioniPagamento2Id" colSpan={2}/>
                </Item>

            </Form>
          </Editing>
              

          <Column dataField="id" visible={false}/>
          <Column dataField="numero" caption="Num" width={110}/>
          <Column dataField="numeroDoc" caption="Num" visible={false}/>
          <Column dataField="dataDoc" dataType="date" format= {'dd/MM/yyyy'} caption="Data doc." />
          <Column dataField="dataConsegna" dataType="date" format= {'dd/MM/yyyy'} caption="Data Consegna" visible={false} />
          <Column dataField="fornitoreId" caption="Fornitore" >
            <Lookup dataSource={fornitori} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="oggetto" caption="Oggetto" />
      
          <Column dataField="descrizione" caption="Descrizione" visible={false}/>
          <Column dataField="codiceCommessa" caption="Commessa" />

          <Column dataField="riferimentoFornitore" caption="Rif. Ordine Fornitore" visible={true}/>
          <Column dataField="commessaFornitore" caption="Rif. Commessa Fornitore" visible={true}/>
          <Column dataField="numeroContratto" caption="Num. Contratto"visible={false}/>

          <Column dataField="master"  visible={false} />
          <Column dataField="riferimentoInternoId" caption="Manager" >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="intermediarioId" caption="Azienda" width={240} visible={false}>
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="imponibile"  width={100} caption="Imponibile">
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoTotale"  width={100} caption="Totale">
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoLordo" visible={false} >
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="percSconto" visible={false} />
          <Column dataField="importoSconto" visible={false} />
          <Column dataField="importoScontato" visible={false} />
          <Column dataField="imposte" visible={false} />
          <Column dataField="statoId" caption="Stato" width={110}>
            <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="valutaId" caption="Valuta" width={80} visible={false}>
            <Lookup dataSource={valute} valueExpr="id" displayExpr="codice" />
          </Column>
          <Column dataField="modalitaPagamentoId"  caption="Modalità Pagamento" visible={false}>
            <Lookup dataSource={modalitaPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamentoId" caption="Condiz. Pagamento Materiali" visible={false}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamento2Id" caption="Condiz. Pagamento Prestazioni" visible={false}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>

          <Column dataField="updateBy" visible={false}/>
          <Column dataField="createBy" visible={false}/>

          

          <Column type="buttons">
            <Button name="edit"  />
            <Button name="delete" visible={hideEditButton}/>
          </Column>

          <MasterDetail
            enabled={true}
            component={supplierOrderDetail}
          />
        </DataGrid>
        
        <div>
          <Popup
            width={800}
            height={640} 
            showTitle={true}
            title="Seleziona Commessa"
            visible={isPopupVisible2}
            hideOnOutsideClick={true}
            onHiding={togglePopup2}
            contentRender={renderContent2}
          > 
          </Popup> 
        </div>

      </div>
    </div>
  </React.Fragment>
  )
};